<template>
  <div>
    <v-icon color="yellow" class="" icon @click="dialog = true"
      >mdi-pencil</v-icon
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Edit Account"
          icon="mdi-account-edit"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-text-field
              outlined
              dense
              label="Username"
              v-model="item.username"
              prepend-icon="mdi-account-circle"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Password"
              v-model="item.password"
              prepend-icon="mdi-form-textbox-password"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Full Name"
              v-model="item.full_name"
              prepend-icon="mdi-account-circle-outline"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Address"
              v-model="item.address"
              prepend-icon="mdi-map-marker"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Phone Number"
              v-model="item.phone_number"
              prepend-icon="mdi-phone"
            ></v-text-field>
            <v-autocomplete
              outlined
              dense
              :items="hats"
              label="Hats"
              v-model="item.hat_ids"
              item-text="name"
              item-value="id"
              multiple
              chips
              small-chips
              deletable-chips
              prepend-icon="mdi-hard-hat"
              hint="Stackable permission bundles - an account can hold several hats"
              persistent-hint
            ></v-autocomplete>
            <v-select
              outlined
              dense
              prepend-icon="mdi-domain"
              :items="branches"
              label="Branch"
              item-text="branch_name"
              item-value="id"
              v-model="item.branch_id"
            ></v-select>
            <v-select
              outlined
              dense
              :items="[0, 1]"
              label="Is Active"
              v-model="item.is_active"
              prepend-icon=""
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" :loading="loading">Edit</v-btn>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      loading: false,
      ready: false,
      dialog: false,
      form: {},
    };
  },
  methods: {
    ...mapActions({
      edit_account: "auth/edit_user",
      fetch_hats: "permission/fetch_hats",
    }),
    async submit() {
      this.loading = true;
      let x = await this.$confirm({
        title: "Edit Account",
        message: "Are you sure you want to edit this account?",
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (x) {
        this.edit_account(this.item).then(() => {
          this.$alert({
            title: "Success",
            message: "Successfully edited a new account",
            color: "success",
            icon: "mdi-check-circle",
          });
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      branches: "branch/branches",
      hats: "permission/hats",
    }),
  },
  watch: {
    dialog(open) {
      if (open) {
        // Seed the multi-select from the account's currently assigned hats.
        this.$set(
          this.item,
          "hat_ids",
          (this.item.hats || []).map((h) => h.id)
        );
        if (this.hats.length == 0) this.fetch_hats();
      }
    },
  },
  async created() {},
};
</script>

<style lang="scss" scoped></style>
